import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  REFERRAL_EDIT,
  REFERRAL_UPDATE,
  USER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { REFERRAL_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const ReferralEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userOptions, setUserOptions] = useState([]);

  const yesNoOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];
  const referralTypeOptions = [
    { value: 1, label: "Myself" },
    { value: 2, label: "Outside" },
  ];
  // const possibilityOptions = [
  //   { value: 1, label: "Cold" },
  //   { value: 2, label: "Prospect" },
  //   { value: 3, label: "Hot" },
  // ];
  const possibilityOptions = [
    // { value: 1, label: "Cold" },
    { value: 2, label: "Prospect" },
    { value: 3, label: "Hot" },
  ];

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    axios
      .put(REFERRAL_UPDATE + id, form)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(REFERRAL_UPDATED);
          navigate("/referrals");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(REFERRAL_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            to_user_id: d.to_user_id,
            to_user_selected: d.to_user_id
              ? { value: Number(d.to_user_id), label: d.to_user_name }
              : null,
            referral_type: d.referral_type,
            referral_type_selected:
              referralTypeOptions.find((o) => o.value === Number(d.referral_type)) ||
              null,
            call_anytime: d.call_anytime,
            call_anytime_selected:
              yesNoOptions.find((o) => o.value === Number(d.call_anytime)) || null,
            relationship_referral: d.relationship_referral,
            relationship_referral_selected:
              yesNoOptions.find(
                (o) => o.value === Number(d.relationship_referral),
              ) || null,
            referral_name: d.referral_name || "",
            referral_phone: d.referral_phone || "",
            referral_email: d.referral_email || "",
            referral_address: d.referral_address || "",
            comments: d.comments || "",
            referral_possibility: d.referral_possibility,
            referral_possibility_selected:
              possibilityOptions.find(
                (o) => o.value === Number(d.referral_possibility),
              ) || null,
            chapter_id: d.chapter_id,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (form.chapter_id == null) return;
    axios
      .get(USER_LIST_DROPDOWN, {
        params: {
          chapter_id: form.chapter_id,
          exclude_other_region_chapter_users: 1,
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setUserOptions(res.data.data || []);
        }
      });
  }, [form.chapter_id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">RFLs</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/referrals"}>
                    <span>RFLs List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Referral</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/referrals"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="to_user_id">
                          Given To<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="to_user_id"
                          options={userOptions}
                          placeholder="Select Member"
                          value={form.to_user_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              to_user_id: selected?.value,
                              to_user_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="to_user_id" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_type">
                          Referral Type<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="referral_type"
                          options={referralTypeOptions}
                          placeholder="Select"
                          value={form.referral_type_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              referral_type: selected?.value,
                              referral_type_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="referral_type" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_name">
                          Referral Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referral_name"
                          placeholder="Referral Name"
                          value={form.referral_name || ""}
                          onChange={(e) =>
                            setForm({ ...form, referral_name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="referral_name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_phone">
                          Referral Phone<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referral_phone"
                          placeholder="Phone"
                          value={form.referral_phone || ""}
                          onChange={(e) =>
                            setForm({ ...form, referral_phone: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="referral_phone" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_email">
                          Referral Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="referral_email"
                          placeholder="Email"
                          value={form.referral_email || ""}
                          onChange={(e) =>
                            setForm({ ...form, referral_email: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="referral_possibility"
                        >
                          Possibility<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="referral_possibility"
                          options={possibilityOptions}
                          placeholder="Select"
                          value={form.referral_possibility_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              referral_possibility: selected?.value,
                              referral_possibility_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="referral_possibility"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="call_anytime">
                          Call Anytime<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="call_anytime"
                          options={yesNoOptions}
                          placeholder="Select"
                          value={form.call_anytime_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              call_anytime: selected?.value,
                              call_anytime_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="call_anytime" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="relationship_referral"
                        >
                          Relationship Referral
                          <span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="relationship_referral"
                          options={yesNoOptions}
                          placeholder="Select"
                          value={form.relationship_referral_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              relationship_referral: selected?.value,
                              relationship_referral_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="relationship_referral"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_address">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referral_address"
                          placeholder="Address"
                          value={form.referral_address || ""}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              referral_address: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="comments">
                          Comments
                        </label>
                        <textarea
                          className="form-control"
                          id="comments"
                          placeholder="Comments"
                          rows={3}
                          value={form.comments || ""}
                          onChange={(e) =>
                            setForm({ ...form, comments: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/referrals"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralEdit;
